var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Scene1'),_c('Scene2'),_c('Scene3'),_c('Scene4')],1)}
var staticRenderFns = []

export { render, staticRenderFns }